import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import { scaleSize } from '~/constants/scale';
import { Theme } from '~/theme';
import { useStyles } from '~/hooks';
import { FontAwesome } from '~/components/core/Icons';

type Props = {
    checked: boolean;
    setChecked: Function;
    disabled?: boolean;
    backgroundColor?: string;
    checkColor?: string;
};

const Checkbox = ({ checked, setChecked, disabled, backgroundColor, checkColor }: Props) => {
    const styles = useStyles(stylesGenerator);

    return (
        <Pressable
            style={[
                styles.checkboxContainer,
                backgroundColor ? { backgroundColor: backgroundColor } : styles.checkboxBackgrouond,
            ]}
            onPress={() => setChecked(disabled && disabled === true ? checked : !checked)}
        >
            {checked ? (
                <FontAwesome name="check" color={checkColor ? checkColor : '#76CAC0'} size={scaleSize(12)} />
            ) : null}
        </Pressable>
    );
};

export default Checkbox;

const stylesGenerator = (theme: Theme) =>
    StyleSheet.create({
        checkboxContainer: {
            height: scaleSize(20),
            width: scaleSize(20),
            borderRadius: scaleSize(5),
            borderColor: theme.equityValue,
            borderWidth: 1,
            justifyContent: 'center',
            alignItems: 'center',
        },
        checkboxBackgrouond: {
            backgroundColor: theme.backgroundSecondary,
        },
    });
